import { Button } from 'antd';
import styled from 'styled-components';

export const EvaluationCardEx = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 12px;
`;

export const ActionButton = styled(Button)`
  font-family: GolosTextWebVF, serif;
  font-size: 12px !important;
  line-height: 14.4px;
  letter-spacing: 0.1px;
  width: 198px;
`;
